import React, { useState, useEffect } from "react";
import { Drawer, IconButton } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import "./ProfilePage.css";
import {
  ProfileTap,
  EmployeeList,
  CompanyProfile,
  UserProfile,
} from "../../Features/Profile/index";
import { Row, Col } from "react-bootstrap";
import { SpinnerLoading } from "../../Components";
import { Link } from "react-router-dom";

const ProfilePage = ({ url, dashboardData, translations , language}) => {
  
  let IsAdmin = false;

  if (dashboardData.length > 0 && dashboardData[0].data && dashboardData[0].data.content === null) {
      IsAdmin = true;
  }
  
  
  const [activeTab, setActiveTab] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  // Simulate loading based on the data being available
  useEffect(() => {
    if (dashboardData && dashboardData.length > 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [dashboardData]);

  const handleTabClick = (index) => {
    setActiveTab(index);
    setDrawerOpen(false); // Close the drawer when a tab is clicked
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setDrawerOpen(open);
  };

  const renderDrawerContent = () => (
    <div className="drawer-profile-tab-content">
      {
        dashboardData.map((template, index) => (
          <div key={index}>
            {template?.data?.content?.allow_profile && (
              <div
                className={`tab ${activeTab === 0 ? "active-tab" : ""}`}
                onClick={() => handleTabClick(0)}
              >
                <ProfileTap
                  title={translations?.message?.myAccount ? translations.message.myAccount : "My Account"}
                  text={translations?.message?.makeChangeAccount ? translations.message.makeChangeAccount : "Make changes to your account"}
                  svg={
                    <svg
                      width="40"
                      height="41"
                      viewBox="0 0 40 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        opacity="0.05"
                        cx="20"
                        cy="20.4258"
                        r="20"
                        className="circle-icon"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M19.9754 22.4432C16.7524 22.4432 14 22.9305 14 24.8821C14 26.8337 16.7349 27.3384 19.9754 27.3384C23.1984 27.3384 25.95 26.8503 25.95 24.8995C25.95 22.9487 23.2159 22.4432 19.9754 22.4432Z"
                        stroke="#2DB0D8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M19.9754 19.6595C22.0905 19.6595 23.8048 17.9444 23.8048 15.8294C23.8048 13.7143 22.0905 12 19.9754 12C17.8604 12 16.1453 13.7143 16.1453 15.8294C16.1381 17.9373 17.8413 19.6524 19.9485 19.6595H19.9754Z"
                        stroke="#2DB0D8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                />
              </div>
            )}
            {template?.data?.content?.allow_company_profile && (
              <div
                className={`tab ${activeTab === 1 ? "active-tab" : ""}`}
                onClick={() => handleTabClick(1)}
              >
                <ProfileTap
                  title={translations?.message?.companyProfile ? translations.message.companyProfile : "Company Profile"}
                  text={translations?.message?.makeChangeCompany ? translations.message.makeChangeCompany : "Make changes to your company profile"}
                  svg={
                    <svg
                      width="40"
                      height="41"
                      viewBox="0 0 40 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        opacity="0.05"
                        cx="20"
                        cy="20.4258"
                        r="20"
                        className="circle-icon"
                      />
                      <path
                        d="M27.4643 26.9286H25.8571V14.0714H26.3929C26.5349 14.0714 26.6712 14.015 26.7717 13.9145C26.8721 13.8141 26.9286 13.6778 26.9286 13.5357C26.9286 13.3936 26.8721 13.2574 26.7717 13.1569C26.6712 13.0564 26.5349 13 26.3929 13H14.6071C14.4651 13 14.3288 13.0564 14.2283 13.1569C14.1279 13.2574 14.0714 13.3936 14.0714 13.5357C14.0714 13.6778 14.1279 13.8141 14.2283 13.9145C14.3288 14.015 14.4651 14.0714 14.6071 14.0714H15.1429V26.9286H13.5357C13.3936 26.9286 13.2574 26.985 13.1569 27.0855C13.0564 27.1859 13 27.3222 13 27.4643C13 27.6064 13.0564 27.7426 13.1569 27.8431C13.2574 27.9436 13.3936 28 13.5357 28H27.4643C27.6064 28 27.7426 27.9436 27.8431 27.8431C27.9436 27.7426 28 27.6064 28 27.4643C28 27.3222 27.9436 27.1859 27.8431 27.0855C27.7426 26.985 27.6064 26.9286 27.4643 26.9286ZM16.2143 14.0714H24.7857V26.9286H22.6429V24.25C22.6429 24.1079 22.5864 23.9717 22.486 23.8712C22.3855 23.7707 22.2492 23.7143 22.1071 23.7143H18.8929C18.7508 23.7143 18.6145 23.7707 18.5141 23.8712C18.4136 23.9717 18.3571 24.1079 18.3571 24.25V26.9286H16.2143V14.0714ZM21.5714 26.9286H19.4286V24.7857H21.5714V26.9286ZM17.8214 16.2143C17.8214 16.0722 17.8779 15.9359 17.9783 15.8355C18.0788 15.735 18.2151 15.6786 18.3571 15.6786H19.4286C19.5707 15.6786 19.7069 15.735 19.8074 15.8355C19.9078 15.9359 19.9643 16.0722 19.9643 16.2143C19.9643 16.3564 19.9078 16.4926 19.8074 16.5931C19.7069 16.6936 19.5707 16.75 19.4286 16.75H18.3571C18.2151 16.75 18.0788 16.6936 17.9783 16.5931C17.8779 16.4926 17.8214 16.3564 17.8214 16.2143ZM21.0357 16.2143C21.0357 16.0722 21.0922 15.9359 21.1926 15.8355C21.2931 15.735 21.4293 15.6786 21.5714 15.6786H22.6429C22.7849 15.6786 22.9212 15.735 23.0217 15.8355C23.1221 15.9359 23.1786 16.0722 23.1786 16.2143C23.1786 16.3564 23.1221 16.4926 23.0217 16.5931C22.9212 16.6936 22.7849 16.75 22.6429 16.75H21.5714C21.4293 16.75 21.2931 16.6936 21.1926 16.5931C21.0922 16.4926 21.0357 16.3564 21.0357 16.2143ZM17.8214 18.8929C17.8214 18.7508 17.8779 18.6145 17.9783 18.5141C18.0788 18.4136 18.2151 18.3571 18.3571 18.3571H19.4286C19.5707 18.3571 19.7069 18.4136 19.8074 18.5141C19.9078 18.6145 19.9643 18.7508 19.9643 18.8929C19.9643 19.0349 19.9078 19.1712 19.8074 19.2717C19.7069 19.3721 19.5707 19.4286 19.4286 19.4286H18.3571C18.2151 19.4286 18.0788 19.3721 17.9783 19.2717C17.8779 19.1712 17.8214 19.0349 17.8214 18.8929ZM21.0357 18.8929C21.0357 18.7508 21.0922 18.6145 21.1926 18.5141C21.2931 18.4136 21.4293 18.3571 21.5714 18.3571H22.6429C22.7849 18.3571 22.9212 18.4136 23.0217 18.5141C23.1221 18.6145 23.1786 18.7508 23.1786 18.8929C23.1786 19.0349 23.1221 19.1712 23.0217 19.2717C22.9212 19.3721 22.7849 19.4286 22.6429 19.4286H21.5714C21.4293 19.4286 21.2931 19.3721 21.1926 19.2717C21.0922 19.1712 21.0357 19.0349 21.0357 18.8929ZM17.8214 21.5714C17.8214 21.4293 17.8779 21.2931 17.9783 21.1926C18.0788 21.0922 18.2151 21.0357 18.3571 21.0357H19.4286C19.5707 21.0357 19.7069 21.0922 19.8074 21.1926C19.9078 21.2931 19.9643 21.4293 19.9643 21.5714C19.9643 21.7135 19.9078 21.8498 19.8074 21.9502C19.7069 22.0507 19.5707 22.1071 19.4286 22.1071H18.3571C18.2151 22.1071 18.0788 22.0507 17.9783 21.9502C17.8779 21.8498 17.8214 21.7135 17.8214 21.5714ZM21.0357 21.5714C21.0357 21.4293 21.0922 21.2931 21.1926 21.1926C21.2931 21.0922 21.4293 21.0357 21.5714 21.0357H22.6429C22.7849 21.0357 22.9212 21.0922 23.0217 21.1926C23.1221 21.2931 23.1786 21.4293 23.1786 21.5714C23.1786 21.7135 23.1221 21.8498 23.0217 21.9502C22.9212 22.0507 22.7849 22.1071 22.6429 22.1071H21.5714C21.4293 22.1071 21.2931 22.0507 21.1926 21.9502C21.0922 21.8498 21.0357 21.7135 21.0357 21.5714Z"
                        fill="#2DB0D8"
                      />
                    </svg>
                  }
                />
              </div>
            )}
            {template?.data?.content?.allow_employee_list && (
              <div
                className={`tab ${activeTab === 2 ? "active-tab" : ""}`}
                onClick={() => handleTabClick(2)}
              >
                <ProfileTap
                  title={translations?.message?.employeeList ? translations.message.employeeList : "Employees List"}
                  text={translations?.message?.viewManageEmployees ? translations.message.viewManageEmployees : "View and manage your employees"}
                  svg={
                    <svg
                      width="40"
                      height="41"
                      viewBox="0 0 40 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        opacity="0.05"
                        cx="20"
                        cy="20.4257"
                        r="20"
                        className="circle-icon"
                      />
                      <path
                        d="M20.2334 19.0611C19.6086 19.0545 18.9997 18.8632 18.4833 18.5113C17.9669 18.1594 17.5663 17.6625 17.3317 17.0834C17.0971 16.5042 17.0391 15.8685 17.1651 15.2565C17.291 14.6444 17.5952 14.0833 18.0393 13.6438C18.4835 13.2042 19.0478 12.9059 19.6611 12.7864C20.2745 12.6669 20.9095 12.7315 21.4862 12.9721C22.0629 13.2128 22.5555 13.6186 22.902 14.1387C23.2485 14.6587 23.4334 15.2696 23.4334 15.8944C23.4276 16.7383 23.0875 17.5453 22.4877 18.1389C21.8879 18.7325 21.0773 19.0641 20.2334 19.0611ZM20.2334 13.8389C19.8284 13.8455 19.4343 13.9716 19.1007 14.2014C18.767 14.4312 18.5088 14.7545 18.3583 15.1306C18.2078 15.5068 18.1718 15.919 18.2549 16.3155C18.3379 16.712 18.5362 17.0752 18.825 17.3593C19.1138 17.6435 19.48 17.836 19.8778 17.9126C20.2757 17.9893 20.6872 17.9466 21.0609 17.7901C21.4346 17.6336 21.7537 17.3702 21.9781 17.0329C22.2025 16.6956 22.3223 16.2996 22.3223 15.8944C22.3165 15.3453 22.0934 14.8208 21.702 14.4357C21.3106 14.0505 20.7826 13.8359 20.2334 13.8389Z"
                        fill="#2DB0D8"
                      />
                      <path
                        d="M20.2332 19.0611C19.6083 19.0545 18.9994 18.8632 18.483 18.5113C17.9667 18.1594 17.566 17.6625 17.3314 17.0834C17.0969 16.5042 17.0389 15.8685 17.1648 15.2565C17.2907 14.6444 17.5949 14.0833 18.0391 13.6438C18.4833 13.2042 19.0475 12.9059 19.6609 12.7864C20.2742 12.6669 20.9092 12.7315 21.4859 12.9721C22.0626 13.2128 22.5552 13.6186 22.9017 14.1387C23.2482 14.6587 23.4331 15.2696 23.4332 15.8944C23.4273 16.7383 23.0872 17.5453 22.4874 18.1389C21.8876 18.7325 21.077 19.0641 20.2332 19.0611ZM20.2332 13.8389C19.8281 13.8455 19.434 13.9716 19.1004 14.2014C18.7668 14.4312 18.5085 14.7545 18.358 15.1306C18.2075 15.5068 18.1716 15.919 18.2546 16.3155C18.3376 16.712 18.536 17.0752 18.8247 17.3593C19.1135 17.6435 19.4798 17.836 19.8776 17.9126C20.2754 17.9893 20.687 17.9466 21.0606 17.7901C21.4343 17.6336 21.7534 17.3702 21.9778 17.0329C22.2022 16.6956 22.322 16.2996 22.3221 15.8944C22.3162 15.3453 22.0932 14.8208 21.7017 14.4357C21.3103 14.0505 20.7823 13.8359 20.2332 13.8389ZM22.1721 19.8056C19.7079 19.3768 17.1711 19.767 14.9498 20.9167C14.7922 21.0042 14.6616 21.1334 14.5724 21.2902C14.4833 21.447 14.4389 21.6253 14.4443 21.8056V23.7833C14.4443 23.9307 14.5028 24.072 14.607 24.1762C14.7112 24.2804 14.8525 24.3389 14.9998 24.3389C15.1472 24.3389 15.2885 24.2804 15.3927 24.1762C15.4969 24.072 15.5554 23.9307 15.5554 23.7833V21.8778C17.6152 20.8442 19.9576 20.5163 22.2221 20.9444L22.1721 19.8056Z"
                        fill="#2DB0D8"
                      />
                      <path
                        d="M28.3331 22.2222H24.6109V21.4C24.6109 21.2527 24.5524 21.1113 24.4482 21.0072C24.344 20.903 24.2027 20.8444 24.0553 20.8444C23.908 20.8444 23.7667 20.903 23.6625 21.0072C23.5583 21.1113 23.4998 21.2527 23.4998 21.4V22.2222H19.4442C19.2969 22.2222 19.1556 22.2808 19.0514 22.3849C18.9472 22.4891 18.8887 22.6304 18.8887 22.7778V28.3333C18.8887 28.4807 18.9472 28.622 19.0514 28.7262C19.1556 28.8304 19.2969 28.8889 19.4442 28.8889H28.3331C28.4805 28.8889 28.6218 28.8304 28.726 28.7262C28.8301 28.622 28.8887 28.4807 28.8887 28.3333V22.7778C28.8887 22.6304 28.8301 22.4891 28.726 22.3849C28.6218 22.2808 28.4805 22.2222 28.3331 22.2222ZM27.7776 27.7778H19.9998V23.3333H23.4998V23.5611C23.4998 23.7085 23.5583 23.8498 23.6625 23.9539C23.7667 24.0581 23.908 24.1167 24.0553 24.1167C24.2027 24.1167 24.344 24.0581 24.4482 23.9539C24.5524 23.8498 24.6109 23.7085 24.6109 23.5611V23.3333H27.7776V27.7778Z"
                        fill="#2DB0D8"
                      />
                      <path
                        d="M22.1169 25.2333H25.428V26.0111H22.1169V25.2333ZM16.0224 16.8C14.4844 16.8257 12.9729 17.206 11.6058 17.9111C11.4571 17.9896 11.3325 18.1071 11.2454 18.251C11.1584 18.3948 11.112 18.5596 11.1113 18.7278V20.45C11.1113 20.5973 11.1699 20.7387 11.274 20.8428C11.3782 20.947 11.5195 21.0056 11.6669 21.0056C11.8142 21.0056 11.9555 20.947 12.0597 20.8428C12.1639 20.7387 12.2224 20.5973 12.2224 20.45V18.8389C13.5287 18.1887 14.975 17.87 16.4336 17.9111C16.2427 17.5629 16.1042 17.1885 16.0224 16.8ZM28.3947 17.9056C27.1685 17.2623 25.8209 16.8838 24.4391 16.7944C24.3577 17.1823 24.2212 17.5565 24.0336 17.9056C25.3353 17.9367 26.614 18.2554 27.778 18.8389V20.45C27.778 20.5973 27.8365 20.7387 27.9407 20.8428C28.0449 20.947 28.1862 21.0056 28.3336 21.0056C28.4809 21.0056 28.6222 20.947 28.7264 20.8428C28.8306 20.7387 28.8891 20.5973 28.8891 20.45V18.7278C28.8894 18.5587 28.8436 18.3927 28.7564 18.2478C28.6693 18.1029 28.5442 17.9845 28.3947 17.9056ZM15.9224 15.8944V15.5222C15.4872 15.464 15.0912 15.2401 14.8169 14.8973C14.5426 14.5544 14.4111 14.119 14.4497 13.6816C14.4884 13.2442 14.6942 12.8386 15.0245 12.5491C15.3547 12.2597 15.7838 12.1088 16.2224 12.1278C16.6787 12.127 17.1173 12.3044 17.4447 12.6222C17.7335 12.384 18.0507 12.1825 18.3891 12.0222C18.0111 11.5876 17.5103 11.2777 16.9527 11.1334C16.395 10.9891 15.8067 11.0171 15.2654 11.2138C14.724 11.4105 14.2549 11.7666 13.92 12.2353C13.585 12.7039 13.3999 13.263 13.3891 13.8389C13.4008 14.5438 13.6748 15.219 14.1576 15.7326C14.6404 16.2463 15.2974 16.5615 16.0002 16.6167C15.9531 16.3787 15.9271 16.137 15.9224 15.8944ZM23.7613 11.0167C23.3795 11.0167 23.0016 11.0929 22.6496 11.2408C22.2976 11.3887 21.9787 11.6052 21.7113 11.8778C22.0869 12.0139 22.4421 12.2008 22.7669 12.4333C23.0262 12.2533 23.3296 12.147 23.6446 12.1258C23.9596 12.1047 24.2745 12.1694 24.5556 12.3131C24.8367 12.4568 25.0736 12.6741 25.2409 12.9418C25.4083 13.2095 25.4998 13.5177 25.5058 13.8333C25.5023 14.1576 25.407 14.4742 25.231 14.7465C25.055 15.0189 24.8055 15.2358 24.5113 15.3722C24.5337 15.5435 24.5448 15.7161 24.5447 15.8889C24.5432 16.1122 24.5246 16.3351 24.4891 16.5556C25.0943 16.4 25.6311 16.0487 26.016 15.5563C26.4008 15.064 26.6121 14.4582 26.6169 13.8333C26.6096 13.0818 26.3051 12.3638 25.7701 11.836C25.235 11.3083 24.5129 11.0137 23.7613 11.0167Z"
                        fill="#2DB0D8"
                      />
                    </svg>
                  }
                />
              </div>
            )}
            {/* <ProfileTap
              title="Choose your language"
              text="English"
              svg={
                <svg
                  width="40"
                  height="41"
                  viewBox="0 0 40 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Group 39793">
                    <g id="Group 39785">
                      <g id="Group 12334">
                        <circle
                          id="Ellipse 643"
                          opacity="0.05"
                          cx="20"
                          cy="20.8408"
                          r="20"
                          className="circle-icon"
                        />
                        <g id="Group">
                          <path
                            id="Vector"
                            d="M12 21C12 25.4184 15.5816 29 20 29C24.4184 29 28 25.4184 28 21C28 16.5816 24.4184 13 20 13C15.5816 13 12 16.5816 12 21Z"
                            stroke="#2DB0D8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            id="Vector_2"
                            d="M20.7999 13.04C20.7999 13.04 23.1999 16.2 23.1999 21C23.1999 25.8 20.7999 28.96 20.7999 28.96M19.1999 28.96C19.1999 28.96 16.7999 25.8 16.7999 21C16.7999 16.2 19.1999 13.04 19.1999 13.04M12.5039 23.8H27.4959M12.5039 18.2H27.4959"
                            stroke="#2DB0D8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              }
            /> */}
            {template?.data?.content?.allow_subscriptions && (
              <a href={'/pricing'}>
                <ProfileTap
                  title={translations?.message?.yourSubscriptions ? translations.message.yourSubscriptions:"Your Subscriptions"}
                  text={translations?.message?.basicPackage ? translations.message.basicPackage:"Basic Package"}
                  svg={
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Group 39794">
                        <g id="Group 39786">
                          <g id="Group 12334">
                            <circle
                              id="Ellipse 643"
                              opacity="0.05"
                              cx="20"
                              cy="20"
                              r="20"
                              className="circle-icon"
                            />
                          </g>
                          <path
                            id="Vector"
                            d="M20.125 27.8333C19.4774 27.8333 18.8583 27.5721 17.621 27.0496C14.5406 25.7481 13 25.0965 13 24.0017V15.9583M20.125 27.8333C20.7726 27.8333 21.3917 27.5721 22.629 27.0496C25.7094 25.7481 27.25 25.0965 27.25 24.0017V15.9583M20.125 27.8333V19.406M15.375 19.9167L16.9583 20.7083M24.0833 13.5833L16.1667 17.5417M17.2164 18.0887L14.904 16.9701C13.6349 16.3557 13 16.0486 13 15.5625C13 15.0764 13.6349 14.7692 14.904 14.1549L17.2156 13.0363C18.6446 12.3452 19.3571 12 20.125 12C20.8929 12 21.6062 12.3452 23.0336 13.0363L25.346 14.1549C26.6151 14.7692 27.25 15.0764 27.25 15.5625C27.25 16.0486 26.6151 16.3557 25.346 16.9701L23.0344 18.0887C21.6054 18.7798 20.8929 19.125 20.125 19.125C19.3571 19.125 18.6438 18.7798 17.2164 18.0887Z"
                            stroke="#2DB0D8"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                      </g>
                    </svg>
                  }
                />
              </a>
              
            )}
          </div>
        ))
      }
    </div>
  );

  return (
    <div className="container">
      {loading ? (
        // Display loading spinner while data is being fetched
        <div className="loading-container">
          <SpinnerLoading  />
        </div>
      ) : (
        <>
          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={toggleDrawer(false)}
            className="drawer"
          >
            {renderDrawerContent()}
          </Drawer>

          {dashboardData.map((template, index) => (
            <Row key={index}>
              <Col
                md={12}
                lg={4}
                className={IsAdmin ? "d-none" : "d-lg-block"}
              >
                {renderDrawerContent()}
              </Col>
              <Col md={12} lg={IsAdmin ? 12 : 8} className="profile-page-content-container">
                <div className="profile-page-content">
                  <div className="profile-tab-button">
                    <IconButton
                      edge="start"
                      color="inherit"
                      aria-label="menu"
                      onClick={toggleDrawer(true)}
                      className="menu-icon"
                    >
                      <SettingsIcon />
                    </IconButton>
                  </div>
                  {activeTab === 0 && <UserProfile url={url} template={template} translations={translations} />}
                  {activeTab === 1 && (
                    <CompanyProfile url={url} template={template} translations={translations} language={language} />
                  )}
                  {activeTab === 2 && (
                    <EmployeeList url={url} template={template} translations={translations} language={language} />
                  )}
                </div>
              </Col>
            </Row>
          ))}
        </>
      )}
    </div>
  );
};

export default ProfilePage;
